import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import {
  Flex,
  Heading,
  Box,
  Button,
  HStack,
} from '@chakra-ui/react'

import SettingsBreadcrumb from '../../../components/SettingsBreadcrumb';
import TabelaMidiaSocial from './tabela-midias-sociais';
import * as api from '../../../api/redesSociais'
import Paginacao from '../../../components/common/paginacao/paginacao';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFacebookSquare, faInstagram, faLinkedin, faYoutube,
  faTiktok, faXTwitter, faWhatsapp, faTelegram, faTumblrSquare
} from '@fortawesome/free-brands-svg-icons';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';

const GerenciarRedesSociais = () => {
  const [redes, setRedes] = useState<any[]>([]);
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [redeSocial, setRedeSocial] = useState<String>();
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate()
  const location = useLocation();

  const { descricaoRede = 'Rede Social', codigoRede = 'defaultCodigo' } = location.state || {};

  const tituloRede = (codigo: number) => {
    const titles: { [key: number]: string } = {
      0: 'Facebook',
      1: 'Instagram',
      2: 'LinkedIn',
      3: 'Youtube',
      4: 'TikTok',
      5: 'X (Antigo Twitter)',
      6: 'Whatsapp',
      7: 'Telegram',
      8: 'Tumblr',
      9: 'Página Internet',
    };

    return titles[codigo] || '';
  };

  const iconeRedeSocial = (id: number) => {
    const icones: { [key: number]: { icon: any, color: string } } = {
      0: { icon: faFacebookSquare, color: "#1789fc" },
      1: { icon: faInstagram, color: "#ec1393" },
      2: { icon: faLinkedin, color: "#1DA1F2" },
      3: { icon: faYoutube, color: "#ff0000" },
      4: { icon: faTiktok, color: "#080404" },
      5: { icon: faXTwitter, color: "#080404" },
      6: { icon: faWhatsapp, color: "#43e460" },
      7: { icon: faTelegram, color: "#088ccc" },
      8: { icon: faTumblrSquare, color: "#384c5c" },
    };

    return icones[id] || { icon: faGlobe, color: "#3b87d8" };
  };

  useEffect(() => {
    const fetchRedeSocial = async () => {
      setLoading(true);
      try {
        const data = await api.listarContasRedesSociais(paginaAtual, itemsPerPage, codigoRede)

        if (data.conteudo && data.conteudo.length > 0) {
          setRedes(data.conteudo.map((categoria: any) => ({
            seqConfigRede: categoria.seqConfigRede,
            dscUsuario: categoria.dscUsuario,
            datRegistro: categoria.datRegistro,
            sitRegistro: categoria.sitRegistro,
          })))
        } else {
          setRedes([])
        }

        setTotalPages(data.totalPaginas)

      } catch (error) {
        console.error('Erro ao buscar contas em redes sociais:', error)
      } finally {
        setLoading(false);
      }
    }

        fetchRedeSocial();
  }, [paginaAtual, itemsPerPage])

  return (
    <Flex p="40px" bgColor="#fafafa" direction="column" w="100%">
      <SettingsBreadcrumb />
      <Heading
        mt="30px"
        fontWeight="600"
        fontSize="21px"
        color="#6F6F6F"
        w="100%"
      >
        Gerenciar Rede Social
      </Heading>
      <Heading
        mt="20px"
        fontWeight="500"
        fontSize="21px"
        w="100%"
      >
        <FontAwesomeIcon
          style={{ marginRight: '10px', fontSize: '25px' }}
          icon={iconeRedeSocial(codigoRede).icon}
          color={iconeRedeSocial(codigoRede).color}
        />
        {`${tituloRede(codigoRede)}`}
      </Heading>
      <Box m="40px 0" w="100%">
        <HStack spacing={5}>
          <Button
            color="#fff"
            bgColor="#1789FC"
            _hover={{
              bgColor: "#1468C9"
            }}
            onClick={() => navigate(`/cms/configuracao/midias-sociais/configurar-rede-social`, {
              state: {
                descricaoRede: descricaoRede,
                codigoRede: codigoRede
              }
            })}
          >
            Adicionar Rede Social
          </Button>
        </HStack>
      </Box>

      <Box>
        <TabelaMidiaSocial 
          listaRedeSocial={redes} 
          listaVazia="Nenhum dado disponível." 
          loading={loading}
        />
      </Box>

      <Paginacao 
        paginaAtual={paginaAtual} 
        totalPages={totalPages} 
        onPageChange={setPaginaAtual}
      />
    </Flex>
  )
}

export default GerenciarRedesSociais
